import { FormHelperText } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Select from "react-select";
import { Card, CardBody, CardHeader } from "../../_metronic/_partials/controls";
import { getAnswers } from "../../api/answer";
import { getGames } from "../../api/game";
import { getGroupsByGame } from "../../api/group";
import { getQuizzes } from "../../api/quiz";
import { getScenes } from "../../api/scene";
import { alertError } from "../../utils/logger";
import {
	QuizResultsTable,
	ResultsTable,
	resultFormatter,
} from "../components/tables/table";

const INITIAL_GROUPS = 10;

function getGameQuizzesData(groups, scenarios, quizzes, answers) {
	let data = [];
	scenarios.forEach((scenario) => {
		let quizzesRes = [];
		quizzes
			.filter(
				(quiz) => quiz.scenario._id === scenario._id && !quiz.supertest
			)
			.forEach((quiz) => {
				let quizRes = {};
				groups.forEach((group, indexGroup) => {
					let answer = answers.find(
						(answer) =>
							answer.quiz === quiz._id &&
							answer.group === group._id
					);
					if (answer) {
						quizRes[`group${indexGroup + 1}`] = {
							pts: answer.score,
							time: answer.time,
							name: group.fullName,
							correct: answer.correct,
						};
					}
				});
				quizRes.quiz = quiz.fullName;
				quizzesRes.push(quizRes);
			});
		let elem = { scenario: scenario.fullName, results: quizzesRes };
		data.push(elem);
	});
	return data;
}

function getGameData(groups, scenarios, answers) {
	let data = [];

	scenarios.forEach((scenario, indexScenario) => {
		let elem = {};
		elem.scenario = `Scenario ${indexScenario + 1}`;
		elem.scenarioName = scenario.fullName;
		groups.forEach((group, indexGroup) => {
			let groupAnswers = answers.filter((answer) => {
				return (
					answer.scenario === scenario._id &&
					answer.group === group._id
				);
			});
			let result = null;
			if (groupAnswers.length)
				result = groupAnswers?.reduce((a, b) => ({
					score: a.score + b.score,
					time: a.time + b.time,
				}));
			if (result)
				elem[`group${indexGroup + 1}`] = {
					pts: result.score,
					time: result.time,
					name: group.fullName,
				};
		});
		data = data.concat(elem);
	});
	return data;
}

export function ResultsPage() {
	const [games, setGames] = useState([]);
	const [groups, setGroups] = useState([]);
	const [quizzes, setQuizzes] = useState([]);
	const [answers, setAnswers] = useState([]);
	const [scenarios, setScenarios] = useState([]);
	const [quizzesData, setQuizzesData] = useState([]);
	const [actualGame, setActualGame] = useState({ fullName: "" });
	const [data, setData] = useState([]);
	const [isExpanded, setIsExpanded] = useState(false);
	const [expandedRows, setExpandedRows] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function styleFormatter(cell, row) {
		if (cell) {
			let max = true;
			let min = true;
			for (let i = 1; i < 10; ++i) {
				if (
					row[`group${i}`]?.pts > cell.pts ||
					(row[`group${i}`]?.pts === cell.pts &&
						row[`group${i}`]?.time < cell.time)
				) {
					max = false;
				}

				if (
					row[`group${i}`]?.pts < cell.pts ||
					(row[`group${i}`]?.pts === cell.pts &&
						row[`group${i}`]?.time > cell.time)
				) {
					min = false;
				}
				if (!min && !max) {
					return;
				}
			}
			if (max) return { backgroundColor: "#c8e6c9" };
			else if (min) return { backgroundColor: "#e6c8c8" };
		}
	}

	function groupFormatter(column, colIndex) {
		console.log("test", colIndex);
		return <div>{groups[colIndex - 1]?.fullName || column.text}</div>;
	}

	const handleOnExpandRow = (row, isExpand, rowIndex, e) => {
		if (isExpand) {
			setExpandedRows([...expandedRows, row.scenario]);
		} else {
			setExpandedRows(expandedRows.filter((x) => x !== row.scenario));
		}
	};

	const expandRow = {
		renderer: (row) => (
			<div style={{ margin: "10px" }}>
				<b>{`${row.scenarioName} | Quizzes Results`}</b>
				<QuizResultsTable
					data={
						quizzesData[row.scenario.match(/\d+/)[0] - 1]?.results
					}
					columns={quizColumns}
				/>
			</div>
		),
		showExpandColumn: true,
		onlyOneExpanding: true,
		expanded: expandedRows,
		onExpand: handleOnExpandRow,
		expandHeaderColumnRenderer: ({ isAnyExpands }) => {
			if (isAnyExpands) {
				return <b>-</b>;
			}
			return <b>+</b>;
		},
		expandColumnRenderer: ({ expanded }) => {
			if (expanded) {
				return <b>-</b>;
			}
			return <b>...</b>;
		},
	};

	const header = (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
			}}
		>
			<h4
				style={{
					textAlign: "center",
					color: "rgb(24, 28, 50)",
					border: "1px solid rgb(215, 218, 231)",
					borderWidth: "0px 0px 2px 0px",
					padding: "0.5em",
				}}
			>
				{"Results"}
			</h4>
		</div>
	);

	const initialColumns = [
		{ dataField: "scenarioName", text: "Scenario" },
		...Array.from({ length: INITIAL_GROUPS }, (_, i) => ({
			dataField: `group${i + 1}`,
			text: `Group ${i + 1}`,
			headerAlign: "center",
			headerFormatter: groupFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		})),
	];

	const [columns, setColumns] = useState(initialColumns);

	const initialQuizColumns = [
		{ dataField: "quiz", text: "Quiz", headerAlign: "center" },
		...Array.from({ length: INITIAL_GROUPS }, (_, i) => ({
			dataField: `group${i + 1}`,
			text: `Group ${i + 1}`,
			headerAlign: "center",
			headerFormatter: groupFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		})),
	];

	const [quizColumns, setQuizColumns] = useState(initialQuizColumns);

	useEffect(() => {
		getGames().then((res) => {
			if (res.status === 200) {
				let games = res.data;
				setGames(res.data);

				if (user?.game) {
					let game = games.find((x) => x._id === user?.game);
					if (game) {
						setActualGame(game);
					}
				}
			}
		});
	}, []);

	useEffect(() => {
		if (!actualGame?._id) return;
		Promise.all([
			getGroupsByGame(actualGame._id),
			getAnswers(actualGame._id),
		])
			.then(([resGroups, resAnswers]) => {
				if (resGroups.status === 200 && resAnswers.status === 200) {
					setGroups(resGroups.data);
					setAnswers(resAnswers.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get game data.",
				});
			});
	}, [actualGame]);

	useEffect(() => {
		if (!actualGame?._id || !groups.length) return;
		setQuizzesData(
			getGameQuizzesData(groups, scenarios, quizzes, answers)
		);
		setData(getGameData(groups, scenarios, answers));
	}, [actualGame, groups, answers, scenarios, quizzes]);

	useEffect(() => {
		const additionalGroups = groups.length - 10;

		const extraColumns =
			additionalGroups > 0
				? Array.from({ length: additionalGroups }, (_, i) => ({
						dataField: `group${i + 11}`,
						text: `Group ${i + 11}`,
						headerAlign: "center",
						headerFormatter: groupFormatter,
						formatter: resultFormatter,
						style: styleFormatter,
				  }))
				: [];

		const extraQuizColumns =
			additionalGroups > 0
				? Array.from({ length: additionalGroups }, (_, i) => ({
						dataField: `group${i + 11}`,
						text: `Group ${i + 11}`,
						headerAlign: "center",
						headerFormatter: groupFormatter,
						formatter: resultFormatter,
				  }))
				: [];

		setColumns([...initialColumns, ...extraColumns]);
		setQuizColumns([...initialQuizColumns, ...extraQuizColumns]);
	}, [groups]);

	useEffect(() => {
		const quizParams = actualGame?._id ? { game: actualGame._id } : {};
		getQuizzes(quizParams)
			.then((res) => {
				if (res.status === 200) setQuizzes(res.data);
			})
			.catch((error) => {
				alertError({ error: error, customMessage: "Could not get quizzes." });
			});
		getScenes()
			.then((res) => {
				if (res.status === 200) setScenarios(res.data);
			})
			.catch((error) => {
				alertError({ error: error, customMessage: "Could not get scenarios." });
			});
		getGames()
			.then((res) => {
				if (res.status === 200) {
					setGames(res.data);
					if (user?.game && res.data?.length) {
						const game = res.data.find((elem) => elem._id === user?.game);
						if (game) setActualGame(game);
					}
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: "Could not get games." });
			});
	}, [refresh, actualGame?._id]);

	return (
		<>
			<Card>
				<CardHeader
					title={`${
						user?.game ? actualGame?.fullName : "Game results"
					}`}
				></CardHeader>
				<CardBody>
					{!user?.game && (
						<>
							<Select
								options={games?.map((game) => ({
									label: game.fullName,
									value: game._id,
								}))}
								value={games
									?.filter(
										(game) => game._id === actualGame._id
									)
									.map((game) => ({
										label: game.fullName,
										value: game._id,
									}))}
								onChange={(value) => {
									setActualGame(
										games.filter(
											(game) => game._id === value.value
										)[0]
									);
									setRefresh(true);
								}}
								isClearable
								isSearchable
								placeholder={`Select game...`}
								className="mb-3 mt-3"
							/>
							<FormHelperText>Select a Game</FormHelperText>
						</>
					)}
					{actualGame.fullName && (
						<ResultsTable
							data={data}
							columns={columns}
							header={header}
							expandRow={expandRow}
						/>
					)}
				</CardBody>
			</Card>
		</>
	);
}
